<template>
  <div class="page-home">
      <video-player :options="options" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
const extMap = {
    'mp4': 'video/mp4',
    'webm': 'video/webm',
    'm3u8': 'application/x-mpegURL',
    'mpd': 'application/dash+xml',
}
// src: 'https://imgcdn-prd.pydp888.com/file/0/3/266583/20180918/5197e55b3726452c7f5635ac3fb16708.mp4'
// poster: 'https://imgcdn-prd.pydp888.com/5/1/0/2127/a8b1ae44a9a5ebf8c12b2d003f7ffabf.png',
export default {
  computed: {
    ...mapGetters("account", ["myUid", "myNick", "myLogo", "isLogined"]),
    options() {
        function extname(name) {
            const dotIndex = name.lastIndexOf('.');
            return name.slice(dotIndex+1).toLowerCase();
        }
        const query = this.$route.query || {}
        return {
          ...query
        }
        // var q = Object.assign({}, this.$route.query)
        // // if (q.src) {
        // //     q.sources = [
        // //         {
        // //             src: q.src,
        // //             type: extMap[extname(q.src)],
        // //         }
        // //     ]
        // //     delete q.src;
        // // }
        // return Object.assign({}, {
        //     // controls: true,
        //     // fluid: true,
        // }, q)
    }
  },
  created() {
      console.log('query: ', this.$route.query);
  },
  methods: {
    ...mapActions("account", ["goLogin", "goLogout"])
  }
};
</script>
